import React from 'react';
import { Button, Dropdown, Space } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = ({ style = {}, type = "text" }) => {
  const { currentLanguage, changeLanguage, getAvailableLanguages, getCurrentLanguageInfo } = useLanguage();
  
  const availableLanguages = getAvailableLanguages();
  const currentLangInfo = getCurrentLanguageInfo();

  // Create menu items for dropdown - only show flag
  const menuItems = availableLanguages.map(lang => ({
    key: lang.code,
    label: (
      <span>{lang.flag}</span>
    ),
    onClick: () => changeLanguage(lang.code)
  }));

  const handleMenuClick = ({ key }) => {
    changeLanguage(key);
  };

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleMenuClick,
        selectedKeys: [currentLanguage]
      }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button 
        type={type}
        icon={<GlobalOutlined />}
        style={{
          color: type === 'text' ? 'rgba(255, 255, 255, 0.65)' : undefined,
          border: 'none',
          ...style
        }}
      >
        <Space>
          <span>{currentLangInfo.flag}</span>
          <span>{currentLangInfo.code.toUpperCase()}</span>
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageToggle;
